<template>
  <v-card-text>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

const ON_OPEN_FORM = 1;
const ON_SEND_FORM = 2;
const ON_SIGN = 4;


export default {
  name: "radio-options",
  data(){
    return {
      onOpeningForm: false,
      onSendingForm: true,
      onSign: false,
    }
  },
  created(){
    this.update({"mode" : ON_SEND_FORM })
    this.onSendingForm = true
  },
  mixins: [ options ]
}
</script>
<style>
</style>
